import { User, UserActionTypes, SET_USER } from "./types";

export const setUser = ({ type, ...values }: User): UserActionTypes => ({
  type: SET_USER,
  userType: type,
  ...values
});
